module.exports = __webpack_public_path__ + "img/notRetrieved.58306829.png";